<template>
  <v-container fluid :grid-list-md="!$vuetify.breakpoint.smAndDown" :pa-0="$vuetify.breakpoint.smAndDown">
    <v-layout wrap row>
      <v-flex xs12 md6>
        <dashboard-documents/>
      </v-flex>
      <v-flex xs12 md6>
        <dashboard-news/>
      </v-flex>
    </v-layout>
<!--    <v-dialog v-model="dialog" max-width="500">-->
<!--      <v-card>-->
<!--        <v-card-text>-->
<!--          {{_showSverkaMessage}}-->
<!--        </v-card-text>-->
<!--        <v-card-actions>-->
<!--          <v-spacer></v-spacer>-->
<!--          <v-btn-->
<!--            color="primary"-->
<!--            flat="flat"-->
<!--            @click="dialog = false"-->
<!--          >-->
<!--            OK-->
<!--          </v-btn>-->
<!--        </v-card-actions>-->
<!--      </v-card>-->
<!--    </v-dialog>-->
  </v-container>
</template>

<script>
import DashboardDocuments from './DashboardDocuments'
import DashboardNews from './DashboardNews'
import { mapGetters } from 'vuex'

export default {
  name: 'dashboard',
  components: {
    DashboardDocuments,
    DashboardNews
  },
  data () {
    return {
      dialog: false
    }
  },
  computed: {
    ...mapGetters('user', {
      _showSverkaMessage: 'showSverkaMessage'
    })
  },
  mounted () {
    if (this._showSverkaMessage) {
      this.dialog = true
    }
  }
}
</script>

<style>
</style>
